export * from './theme';
export * from './roles-permissions';
export * from './brand-tier-ruleset';
export { default as bulkUploadModel } from './bulk-upload-model';
export { default as GlobalStyles } from './styles';

export const AUDIO_CODES_LIST = [
  //{ label: 'MP112', ports: 2 },
  //{ label: 'MP114', ports: 4 },
  //{ label: 'MP118', ports: 8 },
  //{ label: 'MP124', ports: 24 },

  { label: 'MP504', ports: 4 },
  { label: 'MP508', ports: 8 },
  { label: 'MP516', ports: 16 },
  { label: 'MP524', ports: 24 },
  { label: 'MP532', ports: 32 },

  { label: 'MP1288-72', ports: 72 },
  { label: 'MP1288-144', ports: 144 },
  { label: 'MP1288-216', ports: 216 },
  { label: 'MP1288-288', ports: 288 },
]
  .filter(item => !!item)
  .filter(
    (item, index, arr) =>
      arr.findIndex(
        x => String(x.label).toUpperCase() === String(item.label).toUpperCase()
      ) === index
  );
export const AUDIOCODES_FILETYPE = [
  { label: '.CSV', value: 'csv' },
  { label: '.TXT', value: 'txt' },
];
export const APP_LIST = {
  CONDUCTOR: 'Conductor',
  TIME_TRACKER: 'TimeTracker',
  BOILERPLATE: 'Boilerplate',
};

export const INVALID_EXTENSION = {
  all: ['999', '933', '911', '100'],
  ringcentral: ['112', '211', '311', '411', '511', '611', '711', '811'],
  'ringcentral au': ['106', '112'],
  'ringcentral uk': [
    '101',
    '123',
    '141',
    '1470',
    '1471',
    '1475',
    '155',
    '1571',
    '991',
    '992',
    '993',
    '994',
    '995',
    '996',
    '997',
    '998',
    '999',
    '111',
    '112',
    '113',
    '114',
    '115',
    '116',
    '117',
    '118',
    '119',
    '611',
  ],
  'ringcentral eu': [
    '101',
    '123',
    '141',
    '1470',
    '1471',
    '1475',
    '155',
    '1571',
    '991',
    '992',
    '993',
    '994',
    '995',
    '996',
    '997',
    '998',
    '999',
    '111',
    '112',
    '113',
    '114',
    '115',
    '116',
    '117',
    '118',
    '119',
    '611',
  ],
};

export const PHONE_NUMBER_STATUS = {
  READY: 'Ready',
  DIPPING: 'Dipping',
  PORTED: 'Ported',
  PORTING: 'Porting',
  ERROR: 'Error',
  INTERNATIONAL: 'International',
};

export const LOA_SIGNATURE_FONTS = [
  {
    name: 'Default',
    styleClass: 'proxima-novalight',
  },
  {
    name: 'Allura',
    styleClass: 'allura-regular',
  },
  {
    name: 'Homemade Apple',
    styleClass: 'homemade-apple-regular',
  },
  {
    name: 'Rock Salt',
    styleClass: 'rock-salt-regular',
  },
  {
    name: 'Yesteryear',
    styleClass: 'yesteryear-regular',
  },
];

export const NAME_REGEX = /^[^\/]+$/;
export const macAddressRegex =
  /^([0-9A-Fa-f]{2}[:-]){5}([0-9A-Fa-f]{2})$|^([0-9A-Fa-f]{12})$/;
export const BULK_UPLOAD_SECTIONS = [
  {
    description:
      'To add new sites into this workspace, please provide the necessary details to create the new site(s).',
    label: 'Sites',
    value: 'sites',
    tooltipText:
      'Upload sites in csv or excel file formats or download a template to fill-out and upload.',
    sheetName: 'Sites',
  },
  {
    description:
      'To add profile details to site(s) belonging to this workspace, please provide the necessary details.',
    label: 'Profiles',
    value: 'profiles',
    tooltipText:
      'Upload profile in csv or excel file formats or download a template to fill-out and upload.',
    sheetName: 'Site Profiles',
  },
  {
    description:
      'To add new users and invite them into this workspace, please provide the necessary details to create the new user(s).',
    label: 'Users',
    value: 'siteUsers',
    tooltipText:
      'Upload a user list in csv or excel file formats or download a template to fill-out and upload.',
    sheetName: 'Site Users',
  },
  {
    description:
      'To assign devices to user(s) of this workspace, please provide the necessary details of user(s) and device.',
    label: 'Devices',
    value: 'devices',
    tooltipText:
      'Upload a device list in csv or excel file formats or download a template to fill-out and upload.',
    sheetName: 'Devices',
  },
  {
    description:
      'To add new numbers into this workspace, please provide the necessary details to create the new number(s).',
    label: 'Numbers',
    value: 'numbers',
    tooltipText:
      'Upload a number list in csv or excel file formats or download a template to fill-out and upload.',
    sheetName: 'Numbers',
  },
  // {
  //   label: 'Call Handling',
  //   value: 'callHandling',
  //   tooltipText:
  //     'Upload a Call Queue or IVR list in csv or excel file formats or download a template to fill-out and upload.',
  //   sheetName: 'Call Handling',
  // },
];

export const DEFAULT_ERROR_MESSAGE =
  'Something went wrong, please contact system administrator.';
export const DEFAULT_WAIT_MESSAGE =
  'It is taking longer than expected, please wait.';

export const THEME = {
  PURPLE_PANDA: 'Purple Panda',
  BLUE_PANTHER: 'Blue Panther',
  DEFAULT: 'Default',
};

export const THEME_VARIANT = {
  DARK: 'dark',
  LIGHT: 'light',
};

export const LAYOUT = {
  SIDEBAR_HEADER: 'sidebar-header',
  BOX: 'box',
};

export const PAGE_KEYS = {
  ACCOUNT: 'account',
  ACTIVITY: 'activity',
  MANAGE_USERS: 'manage_users',
  SETTINGS: 'settings',
  SITE_DEVICES: 'site-devices',
  SITES: 'sites',
  SITE_USERS: 'site-users',
  TAGS_LIST: 'tags-list',
  PORTING_QUEUE: 'porting-queue',
  LOA_NUMBERS: 'loa-numbers-list',
  PORTING: 'porting',
  CARRIER_GROUP_DETAILS: 'carrier-group-details',
  LOCATION_DETAILS: 'location-details',
  COMPANY_PHONE_NUMBER: 'company-phone-no',
  API_SETTINGS: 'api-setting',
  GLOBAL: 'global',
  SYNC_LOG: 'sync-log',
  MANAGE_ACCOUNTS: 'manage-accounts',
  CUSTOM_FIELDS_LIST: 'custom-fields-list',
};

export const FEEDBACK_TYPES = {
  ISSUE: 'Issue',
  USER_STORY: 'User Story',
};

export const WORKSPACE_STATUS = {
  DIP_SUCCESS: 'Dip Success',
  DIP_ERROR: 'Dip Error',
  DIPPING: 'Dipping',
  PACKAGE_NEEDS_INFO: 'Needs Info',
  PACKAGE_READY: 'Ready',
  PACKAGE_LOA_CREATED: 'Not Signed',
  PACKAGE_LOA_SIGNED: 'LOA Signed',
  PACKAGE_PROCESSING: 'New/Processing',
  PACKAGE_SUBMITTED: 'Submitted',
  PACKAGE_DATE_CONFIRMED: 'Number Transfer Date Confirmed',
  PACKAGE_COMPLETED: 'Completed',
  PACKAGE_ERROR: 'Rejected',
};

export const SUPPORTED_COUNTRIES = [
  {
    callingCode: '1',
    isoCode: 'US',
    name: 'United States',
    postalRegExp: /^[0-9]{5}$/,
  },
  {
    callingCode: '1',
    isoCode: 'CA',
    name: 'Canada',
    postalRegExp: /^[A-Z]{1}[0-9]{1}[A-Z]{1} [0-9]{1}[A-Z]{1}[0-9]{1}$/,
  },
  {
    callingCode: '33',
    isoCode: 'FR',
    name: 'France',
    postalRegExp: /^[0-9]{5}$/,
  },
  {
    callingCode: '44',
    isoCode: 'GB',
    name: 'United Kingdom',
    postalRegExp: /^[A-Z]{1,2}[0-9][A-Z0-9]? ?[0-9][A-Z]{2}$/,
  },
  {
    callingCode: '61',
    isoCode: 'AU',
    name: 'Australia',
    postalRegExp: /^[0-9]{4}$/,
  },
];

export const PhoneRegexE164 = /^$|^\+\d{11,13}$/;

export const PHONE_REGEX = [
  {
    callingCode: '65',
    isoCode: 'SG',
    name: 'Singapore',
    phoneRegex: /^$|^\+\d{10}$/,
  },
];

export const TOAST_TYPES = {
  INFO: 'info',
  ERROR: 'error',
  WARNING: 'warning',
  SUCCESS: 'success',
};

export const TOAST_COLOR = {
  info: '#718093',
  error: '#E84118',
  warning: '#FBC531',
  success: '#4CD137',
};

export const VALIDATIONS = {
  ALPHANUMERIC: 'alphanumeric',
  MAX_LENGTH: 'maxLength',
  MIN_LENGTH: 'minLength',
  MAX: 'max',
  MIN: 'min',
  INTEGER: 'integer',
  FLOAT: 'float',
  NUMBER: 'number',
  REQUIRED: 'required',
  EMAILS: 'emails',
  REGEX: 'regex',
  PHONE: 'phone',
};

export const ENDPOINTS = {
  BULK_EDIT: 'notifications/bulk/edit?ids=:ids',
  CREATE_NOTIFICATION: 'notifications',
  GET_NOTIFICATION: 'notifications?filter[where][id]=:id',
  GET_NOTIFICATIONS: 'notifications',
  PATCH_NOTIFICATION: 'notifications/:id',
  TOGGLE_NOTIFICATIONS: 'notifications/toggle?ids=:ids',
  EXPORT_NOTIFICATIONS: 'notifications/export',
  DELETE_NOTIFICATIONS: 'notifications?ids=:ids',
  DUPLICATE_NOTIFICATIONS: 'notifications/duplicate?ids=:ids',
  GET_USER_DETAILS: 'user/me',
  ACKNOWLEDGE_REGULATION: 'setregulationsacknowledgement',
  SIMULATE: 'notify',
  UPDATE_PREFERENCES: 'setuserpreferences',
};

export const sessionExpireMsg =
  'Session expired. Redirecting to login screen...';

export const ICONS = {
  FILTER: 'Filter',
  EXPORT: 'Export',
  LOCK: 'Lock',
  UNLOCK: 'Unlock',
  TUNE: 'Tune datatable',
};

export const SECTIONS = {
  SITES: 'site_lock',
  NUMBERS: 'number_lock',
  SITE_USERS: 'user_lock',
  DEVICES: 'device_lock',
  CALL_HANDLING: 'callhandling_lock',
};

export const RCEXTENSION_LOCATION = [
  'Use unassigned extension matching selected country',
  'Use unassigned extension from a different country',
  'None',
];

export const bulkModelUniqueProperty = {
  sites: 'name',
  profiles: 'site_name',
  siteUsers: 'email',
  devices: 'email',
};

export const TASK_STATUS = [
  {
    label: 'Not started',
    className: 'color-grey',
    circleClassName: 'bg-grey',
  },
  {
    label: 'Started',
    className: 'color-success',
    circleClassName: 'bg-success',
  },
  {
    label: 'Needs info',
    className: 'color-error',
    circleClassName: 'bg-danger',
  },
  {
    label: 'Completed',
    className: 'color-info',
    circleClassName: 'bg-info',
  },
];

export const deviceType = {
  newDevice: 'New Device',
  existingDevice: 'Existing Device',
  softPhone: 'Softphone',
};

export const TEAM_PROFILE_BATCH_LIMIT = 30;

export const USER_POSTIONS = {
  buildAdvisor: 'Build Advisor',
  planningAndDesignEngineer: 'Planning & Design Engineer (P&D)',
  projectManager: 'Project Manager (PM)',
  other: 'Other',
};

export const EXISTING_DEVICES = {
  manual: [
    {
      sku: 'DV-0',
      type: 'ExistingDevice',
      model: {
        id: '0',
        name: 'Other',
        deviceClass: 'Unknown',
        addons: [],
        features: [],
      },
    },
  ],
  supported: [
    {
      sku: 'DV-0',
      type: 'ExistingDevice',
      model: {
        id: '0',
        name: 'Cisco 2102 ATA',
        deviceClass: 'Unknown',
        addons: [],
        features: [],
      },
    },
    {
      sku: 'DV-0',
      type: 'ExistingDevice',
      model: {
        id: '0',
        name: 'Cisco PAP2T ATA',
        deviceClass: 'Unknown',
        addons: [],
        features: [],
      },
    },
    {
      sku: 'DV-0',
      type: 'ExistingDevice',
      model: {
        id: '0',
        name: 'Cisco SPA 122 ATA',
        deviceClass: 'Unknown',
        addons: [],
        features: [],
      },
    },
    {
      sku: 'DV-0',
      type: 'ExistingDevice',
      model: {
        id: '0',
        name: 'Cisco SPA 504G',
        deviceClass: 'Unknown',
        addons: [],
        features: [],
      },
    },
    {
      sku: 'DV-0',
      type: 'ExistingDevice',
      model: {
        id: '0',
        name: 'Cisco SPA 509G',
        deviceClass: 'Unknown',
        addons: [],
        features: [],
      },
    },
    {
      sku: 'DV-0',
      type: 'ExistingDevice',
      model: {
        id: '0',
        name: 'Cisco SPA 525G2',
        deviceClass: 'Unknown',
        addons: [],
        features: [],
      },
    },
    {
      sku: 'DV-0',
      type: 'ExistingDevice',
      model: {
        id: '0',
        name: 'Polycom SPIP 321',
        deviceClass: 'Unknown',
        addons: [],
        features: [],
      },
    },
    {
      sku: 'DV-0',
      type: 'ExistingDevice',
      model: {
        id: '0',
        name: 'Polycom SPIP 331',
        deviceClass: 'Unknown',
        addons: [],
        features: [],
      },
    },
    {
      sku: 'DV-0',
      type: 'ExistingDevice',
      model: {
        id: '0',
        name: 'Polycom SPIP 335',
        deviceClass: 'Unknown',
        addons: [],
        features: [],
      },
    },
    {
      sku: 'DV-0',
      type: 'ExistingDevice',
      model: {
        id: '0',
        name: 'Polycom SPIP 450',
        deviceClass: 'Unknown',
        addons: [],
        features: [],
      },
    },
    {
      sku: 'DV-0',
      type: 'ExistingDevice',
      model: {
        id: '0',
        name: 'Polycom SPIP 550',
        deviceClass: 'Unknown',
        addons: [],
        features: [],
      },
    },
    {
      sku: 'DV-0',
      type: 'ExistingDevice',
      model: {
        id: '0',
        name: 'Polycom SPIP 560',
        deviceClass: 'Unknown',
        addons: [],
        features: [],
      },
    },
    {
      sku: 'DV-0',
      type: 'ExistingDevice',
      model: {
        id: '0',
        name: 'Polycom SPIP 650',
        deviceClass: 'Unknown',
        addons: [],
        features: [],
      },
    },
    {
      sku: 'DV-0',
      type: 'ExistingDevice',
      model: {
        id: '0',
        name: 'Polycom SPIP 670',
        deviceClass: 'Unknown',
        addons: [],
        features: [],
      },
    },
    {
      sku: 'DV-0',
      type: 'ExistingDevice',
      model: {
        id: '0',
        name: 'Polycom SSIP 7000',
        deviceClass: 'Unknown',
        addons: [],
        features: [],
      },
    },
    {
      sku: 'DV-0',
      type: 'ExistingDevice',
      model: {
        id: '0',
        name: 'Polycom VVX-101',
        deviceClass: 'Unknown',
        addons: [],
        features: [],
      },
    },
    {
      sku: 'DV-0',
      type: 'ExistingDevice',
      model: {
        id: '0',
        name: 'Polycom VVX-201',
        deviceClass: 'Unknown',
        addons: [],
        features: [],
      },
    },
    {
      sku: 'DV-0',
      type: 'ExistingDevice',
      model: {
        id: '0',
        name: 'Polycom VVX-300',
        deviceClass: 'Unknown',
        addons: [],
        features: [],
      },
    },
    {
      sku: 'DV-0',
      type: 'ExistingDevice',
      model: {
        id: '0',
        name: 'Polycom VVX-301',
        deviceClass: 'Unknown',
        addons: [],
        features: [],
      },
    },
    {
      sku: 'DV-0',
      type: 'ExistingDevice',
      model: {
        id: '0',
        name: 'Polycom VVX-310',
        deviceClass: 'Unknown',
        addons: [],
        features: [],
      },
    },
    {
      sku: 'DV-0',
      type: 'ExistingDevice',
      model: {
        id: '0',
        name: 'Polycom VVX-311',
        deviceClass: 'Unknown',
        addons: [],
        features: [],
      },
    },
    {
      sku: 'DV-0',
      type: 'ExistingDevice',
      model: {
        id: '0',
        name: 'Polycom VVX-400',
        deviceClass: 'Unknown',
        addons: [],
        features: [],
      },
    },
    {
      sku: 'DV-0',
      type: 'ExistingDevice',
      model: {
        id: '0',
        name: 'Polycom VVX-410',
        deviceClass: 'Unknown',
        addons: [],
        features: [],
      },
    },
    {
      sku: 'DV-0',
      type: 'ExistingDevice',
      model: {
        id: '0',
        name: 'Polycom VVX-411',
        deviceClass: 'Unknown',
        addons: [],
        features: [],
      },
    },
    {
      sku: 'DV-0',
      type: 'ExistingDevice',
      model: {
        id: '0',
        name: 'Polycom VVX-500',
        deviceClass: 'Unknown',
        addons: [],
        features: [],
      },
    },
    {
      sku: 'DV-0',
      type: 'ExistingDevice',
      model: {
        id: '0',
        name: 'Polycom VVX-600',
        deviceClass: 'Unknown',
        addons: [],
        features: [],
      },
    },
    {
      sku: 'DV-0',
      type: 'ExistingDevice',
      model: {
        id: '0',
        name: 'Yealink T21P',
        deviceClass: 'Unknown',
        addons: [],
        features: [],
      },
    },
    {
      sku: 'DV-0',
      type: 'ExistingDevice',
      model: {
        id: '0',
        name: 'Yealink W52P',
        deviceClass: 'Unknown',
        addons: [],
        features: [],
      },
    },
    {
      sku: 'DV-0',
      type: 'ExistingDevice',
      model: {
        id: '0',
        name: 'Yealink W56P',
        deviceClass: 'Unknown',
        addons: [],
        features: [],
      },
    },
  ],
};
export const FAX_TYPES = [
  'None',
  'ATA + Fax Machine',
  'E-Fax',
  'POTS Line (outside RC)',
];

export const GROUP_STATUSES = {
  READY: 'Ready',
  NEEDS_INFO: 'Needs Info',
};

export const PORT_PACKAGE_STATUS = {
  NEEDS_INFO: {
    label: 'Needs Info',
    progressValue: null,
    step: 1,
    color: '#7b8aa4',
  },
  NOT_SIGNED: {
    label: 'Not Signed',
    color: 'warning',
    shade: 'light',
    progressValue: 0,
    step: 3,
  },
  READY: {
    label: 'Ready',
    color: 'warning',
    shade: 'light',
    progressValue: null,
    step: 2,
  },
  NEW_PROCESSING: {
    label: 'New/Processing',
    color: 'warning',
    shade: 'dark',
    progressValue: 25,
    step: 5,
  },
  LOA_SIGNED: {
    label: 'LOA Signed',
    color: 'warning',
    shade: 'dark',
    progressValue: null,
    step: 4,
  },
  SUBMITTED: {
    label: 'Submitted',
    color: 'warning',
    shade: 'light',
    progressValue: 50,
    step: 6,
  },
  DATE_CONFIRMED: {
    label: 'Number Transfer Date Confirmed',
    progressValue: 75,
    step: 7,
    color: 'warning',
    shade: 'light',
  },
  REJECTED: {
    label: 'Rejected',
    color: 'error',
    progressValue: 100,
    step: 8,
  },
  COMPLETED: {
    label: 'Completed',
    progressValue: 100,
    step: 8,
  },
};

export const getPortPackageStatus = statusLabel => {
  return Object.values(PORT_PACKAGE_STATUS).find(
    status => status.label === statusLabel
  );
};

export const countryList = [
  'Afghanistan',
  'AF',
  'AFG',
  'Albania',
  'AL',
  'ALB',
  'Algeria',
  'DZ',
  'DZA',
  'American Samoa',
  'AS',
  'ASM',
  'Andorra',
  'AD',
  'AND',
  'Angola',
  'AO',
  'AGO',
  'Anguilla',
  'AI',
  'AIA',
  'Antarctica',
  'AQ',
  'ATA',
  'Antigua and Barbuda',
  'AG',
  'ATG',
  'Argentina',
  'AR',
  'ARG',
  'Armenia',
  'AM',
  'ARM',
  'Aruba',
  'AW',
  'ABW',
  'Australia',
  'AU',
  'AUS',
  'Austria',
  'AT',
  'AUT',
  'Azerbajjan',
  'AZ',
  'AZE',
  'Bahamas',
  'BS',
  'BHS',
  'Bahrain',
  'BH',
  'BHR',
  'Bangladesh',
  'BD',
  'BGD',
  'Barbados',
  'BB',
  'BRB',
  'Belarus',
  'BY',
  'BLR',
  'Belgium',
  'BE',
  'BEL',
  'Belize',
  'BZ',
  'BLZ',
  'Benin',
  'BJ',
  'BEN',
  'Bermuda',
  'BM',
  'BMU',
  'Bhutan',
  'BT',
  'BTN',
  'Bolivia',
  'BO',
  'BOL',
  'Bonaire',
  'BQ',
  'BES',
  'Bosnia and Herzegovina',
  'BA',
  'BIH',
  'Botswana',
  'BW',
  'BWA',
  'Bouvet Island',
  'BV',
  'BVT',
  'Brazil',
  'BR',
  'BRA',
  'British Indian Ocean Territory',
  'IO',
  'IOT',
  'Brunel Darussalam',
  'BN',
  'BRN',
  'Bulgaria',
  'BG',
  'BGR',
  'Burkina Faso',
  'BF',
  'BFA',
  'Burundi',
  'BI',
  'BDI',
  'Cambodia',
  'KH',
  'KHM',
  'Cameron',
  'CM',
  'CMR',
  'Canada',
  'CA',
  'CAN',
  'Cape Verde',
  'CV',
  'CPV',
  'Cayman Islands',
  'KY',
  'CYM',
  'Central African Republic',
  'CF',
  'CAF',
  'Chad',
  'TD',
  'TCD',
  'Chile',
  'CL',
  'CHL',
  'China',
  'CN',
  'CHN',
  'Christmas Island',
  'CX',
  'CXR',
  'Cocos (Keeling) Islands',
  'CC',
  'CCK',
  'Colombia',
  'CO',
  'COL',
  'Comoros',
  'KM',
  'COM',
  'Congo',
  'CG',
  'COG',
  'Democratic Republic of the Congo',
  'CD',
  'COD',
  'Cook Islands',
  'CK',
  'COK',
  'Costa Rica',
  'CR',
  'CRI',
  'Croatia',
  'HR',
  'HRV',
  'Cuba',
  'CU',
  'CUB',
  'Curacao',
  'CW',
  'CUW',
  'Cyprus',
  'CY',
  'CYP',
  'Czech Republic',
  'CZ',
  'CZE',
  "Cote d'Ivore",
  'CI',
  'CIV',
  'Denmark',
  'DK',
  'DNK',
  'Djibouti',
  'DJ',
  'DJI',
  'Dominica',
  'DM',
  'DMA',
  'Dominican Republic',
  'DO',
  'DOM',
  'Ecuador',
  'EC',
  'ECU',
  'Egypt',
  'EG',
  'EGY',
  'El Salvador',
  'SV',
  'SLV',
  'Equatorial Guinea',
  'GQ',
  'GNQ',
  'Entrea',
  'ER',
  'ERI',
  'Estonia',
  'EE',
  'EST',
  'Ethiopia',
  'ET',
  'ETH',
  'Falkland Islands (Malvinas)',
  'FK',
  'FLK',
  'Faroe Islands',
  'FO',
  'FRO',
  'Fiji',
  'FJ',
  'FJI',
  'Finland',
  'FI',
  'FIN',
  'France',
  'FR',
  'FRA',
  'French Gulana',
  'GF',
  'GUF',
  'French Polynesia',
  'PF',
  'PYF',
  'French Southern Territories',
  'TF',
  'ATF',
  'Gabon',
  'GA',
  'GAB',
  'Gambia',
  'GM',
  'GMB',
  'Georgia',
  'GE',
  'GEO',
  'Germany',
  'DE',
  'DEU',
  'Ghana',
  'GH',
  'GHA',
  'Gibraltar',
  'GI',
  'GIB',
  'Greece',
  'GR',
  'GRC',
  'Greenland',
  'GL',
  'GRL',
  'Grenada',
  'GD',
  'GRD',
  'Guadeloupe',
  'GP',
  'GLP',
  'Guam',
  'GU',
  'GUM',
  'Guatemala',
  'GT',
  'GTM',
  'Guernsey',
  'GG',
  'GGY',
  'Guinea',
  'GN',
  'GIN',
  'Guinea-Bissau',
  'GW',
  'GNB',
  'Guyana',
  'GY',
  'GUY',
  'Haiti',
  'HT',
  'HTI',
  'Heard Island and McDonald Islands',
  'HM',
  'HMD',
  'Holy See(Vatican City State)',
  'VA',
  'VAT',
  'Honduras',
  'HN',
  'HND',
  'Hong Kong',
  'HK',
  'HKG',
  'Hungary',
  'HU',
  'HUN',
  'Iceland',
  'IS',
  'ISL',
  'India',
  'IN',
  'IND',
  'Indonesia',
  'ID',
  'IDN',
  'Islamic Republic of Iran',
  'IR',
  'IRN',
  'Iraq',
  'IQ',
  'IRQ',
  'Ireland',
  'IE',
  'IRL',
  'Isle of Man',
  'IM',
  'IMN',
  'Israel',
  'IL',
  'ISR',
  'Italy',
  'IT',
  'ITA',
  'Jamaica',
  'JM',
  'JAM',
  'Japan',
  'JP',
  'JPN',
  'Jersey',
  'JE',
  'JEY',
  'Jordan',
  'JO',
  'JOR',
  'Kazakhstan',
  'KZ',
  'KAZ',
  'Kenya',
  'KE',
  'KEN',
  'Kiribati',
  'KI',
  'KIR',
  "Democratic People's Republic of Korea",
  'KP',
  'PRK',
  'Republic of Korea',
  'KR',
  'KOR',
  'Kuwait',
  'KW',
  'KWT',
  'Kyrgyzstan',
  'KG',
  'KGZ',
  "Lao People's Democratic Republic",
  'LA',
  'LAO',
  'Latvia',
  'LV',
  'LVA',
  'Lebanon',
  'LB',
  'LBN',
  'Lesotho',
  'LS',
  'LSO',
  'Liberia',
  'LR',
  'LBR',
  'Libya',
  'LY',
  'LBY',
  'Liechtenstein',
  'LI',
  'LIE',
  'Lithuania',
  'LT',
  'LTU',
  'Luxembourg',
  'LU',
  'LUX',
  'Macao',
  'MO',
  'MAC',
  'The Former Yugoslav Republic of Macedonia',
  'MK',
  'MKD',
  'Madagascar',
  'MG',
  'MDG',
  'Malawi',
  'MW',
  'MWI',
  'Malaysia',
  'MY',
  'MYS',
  'Maldives',
  'MV',
  'MDV',
  'Mali',
  'ML',
  'MLI',
  'Malta',
  'MT',
  'MLT',
  'Marshall Islands',
  'MH',
  'MHL',
  'Martinique',
  'MQ',
  'MTQ',
  'Mauritania',
  'MR',
  'MRT',
  'Mauritius',
  'MU',
  'MUS',
  'Mayotte',
  'YT',
  'MYT',
  'Mexico',
  'MX',
  'MEX',
  'Federated States of Micronesia',
  'FM',
  'FSM',
  'Republic of Moldova',
  'MD',
  'MDA',
  'Monaco',
  'MC',
  'MCO',
  'Mongolia',
  'MN',
  'MNG',
  'Montenegro',
  'ME',
  'MNE',
  'Montserrat',
  'MS',
  'MSR',
  'Morocco',
  'MA',
  'MAR',
  'Mozambique',
  'MZ',
  'MOZ',
  'Myanmar',
  'MM',
  'MMR',
  'Namibia',
  'NA',
  'NAM',
  'Nauru',
  'NR',
  'NRU',
  'Nepal',
  'NP',
  'NPL',
  'Netherlands',
  'NL',
  'NLD',
  'New Caledonia',
  'NC',
  'NCL',
  'New Zealand',
  'NZ',
  'NZL',
  'Nicaragua',
  'NI',
  'NIC',
  'Niger',
  'NER',
  'NE',
  'Nigeria',
  'NG',
  'NGA',
  'Niue',
  'NU',
  'NIU',
  'Norfolk Island',
  'NF',
  'NFK',
  'Northern Mariana Islands',
  'MP',
  'MNP',
  'Norway',
  'NO',
  'NOR',
  'Oman',
  'OM',
  'OMN',
  'Pakistan',
  'PK',
  'PAK',
  'Palau',
  'PW',
  'PLW',
  'State of Palestine',
  'PS',
  'PSE',
  'Panama',
  'PA',
  'PAN',
  'Papua New Guinea',
  'PG',
  'PNG',
  'Paraguay',
  'PY',
  'PRY',
  'Peru',
  'PE',
  'PER',
  'Philippines',
  'PH',
  'PHL',
  'Pitcairn',
  'PN',
  'PCN',
  'Poland',
  'PL',
  'POL',
  'Portugal',
  'PT',
  'PRT',
  'Puerto Rico',
  'PR',
  'PRI',
  'Qatar',
  'QA',
  'QAT',
  'Romania',
  'RO',
  'ROU',
  'Russian Federation',
  'RU',
  'RUS',
  'Rwanda',
  'RW',
  'RWA',
  'Reunion',
  'RE',
  'REU',
  'Saint Barthelemy',
  'BL',
  'BLM',
  'Saint Helena',
  'SH',
  'SHN',
  'Saint Kitts and Nevis',
  'KN',
  'KNA',
  'Saint Lucia',
  'LC',
  'LCA',
  'Saint Martin (French part)',
  'MF',
  'MAF',
  'Saint Pierre and Miquelon',
  'PM',
  'SPM',
  'Saint Vincent and the Grenadines',
  'VC',
  'VCT',
  'Samoa',
  'WS',
  'WSM',
  'San Marino',
  'SM',
  'SMR',
  'Sao Tome and Principe',
  'ST',
  'STP',
  'Saudi Arabia',
  'SA',
  'SAU',
  'Senegal',
  'SN',
  'SEN',
  'Serbia',
  'RS',
  'SRB',
  'Seychelles',
  'SC',
  'SYC',
  'Sierra Leone',
  'Singapore',
  'SG',
  'SGP',
  'Sint Maarten (Dutch Part)',
  'SX',
  'SXM',
  'Slovakia',
  'SK',
  'SVK',
  'Slovenia',
  'SI',
  'SVN',
  'Solomon Islands',
  'Somalia',
  'SO',
  'SOM',
  'South Africa',
  'ZA',
  'ZAF',
  'South Georgia and the South Sandwich Islands',
  'GS',
  'SGS',
  'South Sudan',
  'SS',
  'SSD',
  'Spain',
  'ES',
  'ESP',
  'Sri Lanka',
  'LK',
  'LKA',
  'Sudan',
  'SD',
  'SDN',
  'Suriname',
  'SR',
  'SUR',
  'Svalbard and Jan Mayen',
  'SJ',
  'SJM',
  'Swaziland',
  'SZ',
  'SWZ',
  'Sweden',
  'SE',
  'SWE',
  'Switzerland',
  'CH',
  'CHE',
  'Syrian Arab Republic',
  'SY',
  'SYR',
  'Taiwan',
  'TW',
  'TWN',
  'Tajikistan',
  'TJ',
  'TJK',
  'United Republic of Tanzania',
  'TZ',
  'TZA',
  'Thailand',
  'TH',
  'THA',
  'Timor-Leste',
  'TL',
  'TLS',
  'Togo',
  'TG',
  'TGO',
  'Tokelau',
  'TK',
  'TKL',
  'Tonga',
  'TO',
  'TON',
  'Trinidad and Tobago',
  'TT',
  'TTO',
  'Tunisia',
  'TN',
  'TUN',
  'Turkey',
  'TR',
  'TUR',
  'Turkmenistan',
  'TM',
  'TKM',
  'Turks and Caicos Islands',
  'TC',
  'TCA',
  'Tuvalu',
  'TV',
  'TUV',
  'Uganda',
  'UG',
  'UGA',
  'Ukraine',
  'UA',
  'UKR',
  'United Arab Emirates',
  'AE',
  'ARE',
  'United Kingdom',
  'GB',
  'GBR',
  'United States',
  'US',
  'USA',
  'United States Minor Outlying Islands',
  'UM',
  'UMI',
  'Uruguay',
  'UY',
  'URY',
  'Uzbekistan',
  'UZ',
  'UZB',
  'Vanuatu',
  'VU',
  'VUT',
  'Venezuela',
  'VE',
  'VEN',
  'Viet Nam',
  'VN',
  'VNM',
  'British Virgin Islands',
  'VG',
  'VGB',
  'US Virgin Islands',
  'VI',
  'VIR',
  'Wallis and Futuna',
  'WF',
  'WLF',
  'Western Sahara',
  'EH',
  'ESH',
  'Yemen',
  'YE',
  'YEM',
  'Zambia',
  'ZM',
  'ZMB',
  'Zimbabwe',
  'ZW',
  'ZWE',
];

export const countryListMap = [
  {
    name: 'Afghanistan',
    iso: 'AF',
    isoAlt: 'AFG',
  },
  {
    name: 'Albania',
    iso: 'AL',
    isoAlt: 'ALB',
  },
  {
    name: 'Algeria',
    iso: 'DZ',
    isoAlt: 'DZA',
  },
  {
    name: 'American Samoa',
    iso: 'AS',
    isoAlt: 'ASM',
  },
  {
    name: 'Andorra',
    iso: 'AD',
    isoAlt: 'AND',
  },
  {
    name: 'Angola',
    iso: 'AO',
    isoAlt: 'AGO',
  },
  {
    name: 'Anguilla',
    iso: 'AI',
    isoAlt: 'AIA',
  },
  {
    name: 'Antarctica',
    iso: 'AQ',
    isoAlt: 'ATA',
  },
  {
    name: 'Antigua and Barbuda',
    iso: 'AG',
    isoAlt: 'ATG',
  },
  {
    name: 'Argentina',
    iso: 'AR',
    isoAlt: 'ARG',
  },
  {
    name: 'Armenia',
    iso: 'AM',
    isoAlt: 'ARM',
  },
  {
    name: 'Aruba',
    iso: 'AW',
    isoAlt: 'ABW',
  },
  {
    name: 'Australia',
    iso: 'AU',
    isoAlt: 'AUS',
  },
  {
    name: 'Austria',
    iso: 'AT',
    isoAlt: 'AUT',
  },
  {
    name: 'Azerbaijan',
    iso: 'AZ',
    isoAlt: 'AZE',
  },
  {
    name: 'Bahamas',
    iso: 'BS',
    isoAlt: 'BHS',
  },
  {
    name: 'Bahrain',
    iso: 'BH',
    isoAlt: 'BHR',
  },
  {
    name: 'Bangladesh',
    iso: 'BD',
    isoAlt: 'BGD',
  },
  {
    name: 'Barbados',
    iso: 'BB',
    isoAlt: 'BRB',
  },
  {
    name: 'Belarus',
    iso: 'BY',
    isoAlt: 'BLR',
  },
  {
    name: 'Belgium',
    iso: 'BE',
    isoAlt: 'BEL',
  },
  {
    name: 'Belize',
    iso: 'BZ',
    isoAlt: 'BLZ',
  },
  {
    name: 'Benin',
    iso: 'BJ',
    isoAlt: 'BEN',
  },
  {
    name: 'Bermuda',
    iso: 'BM',
    isoAlt: 'BMU',
  },
  {
    name: 'Bhutan',
    iso: 'BT',
    isoAlt: 'BTN',
  },
  {
    name: 'Bolivia',
    iso: 'BO',
    isoAlt: 'BOL',
  },
  {
    name: 'Bonaire',
    iso: 'BQ',
    isoAlt: 'BES',
  },
  {
    name: 'Bosnia and Herzegovina',
    iso: 'BA',
    isoAlt: 'BIH',
  },
  {
    name: 'Botswana',
    iso: 'BW',
    isoAlt: 'BWA',
  },
  {
    name: 'Bouvet Island',
    iso: 'BV',
    isoAlt: 'BVT',
  },
  {
    name: 'Brazil',
    iso: 'BR',
    isoAlt: 'BRA',
  },
  {
    name: 'British Indian Ocean Territory',
    iso: 'IO',
    isoAlt: 'IOT',
  },
  {
    name: 'Brunei Darussalam',
    iso: 'BN',
    isoAlt: 'BRN',
  },
  {
    name: 'Bulgaria',
    iso: 'BG',
    isoAlt: 'BGR',
  },
  {
    name: 'Burkina Faso',
    iso: 'BF',
    isoAlt: 'BFA',
  },
  {
    name: 'Burundi',
    iso: 'BI',
    isoAlt: 'BDI',
  },
  {
    name: 'Cambodia',
    iso: 'KH',
    isoAlt: 'KHM',
  },
  {
    name: 'Cameroon',
    iso: 'CM',
    isoAlt: 'CMR',
  },
  {
    name: 'Canada',
    iso: 'CA',
    isoAlt: 'CAN',
  },
  {
    name: 'Cape Verde',
    iso: 'CV',
    isoAlt: 'CPV',
  },
  {
    name: 'Cayman Islands',
    iso: 'KY',
    isoAlt: 'CYM',
  },
  {
    name: 'Central African Republic',
    iso: 'CF',
    isoAlt: 'CAF',
  },
  {
    name: 'Chad',
    iso: 'TD',
    isoAlt: 'TCD',
  },
  {
    name: 'Chile',
    iso: 'CL',
    isoAlt: 'CHL',
  },
  {
    name: 'China',
    iso: 'CN',
    isoAlt: 'CHN',
  },
  {
    name: 'Christmas Island',
    iso: 'CX',
    isoAlt: 'CXR',
  },
  {
    name: 'Cocos (Keeling) Islands',
    iso: 'CC',
    isoAlt: 'CCK',
  },
  {
    name: 'Colombia',
    iso: 'CO',
    isoAlt: 'COL',
  },
  {
    name: 'Comoros',
    iso: 'KM',
    isoAlt: 'COM',
  },
  {
    name: 'Congo',
    iso: 'CG',
    isoAlt: 'COG',
  },
  {
    name: 'Democratic Republic of the Congo',
    iso: 'CD',
    isoAlt: 'COD',
  },
  {
    name: 'Cook Islands',
    iso: 'CK',
    isoAlt: 'COK',
  },
  {
    name: 'Costa Rica',
    iso: 'CR',
    isoAlt: 'CRI',
  },
  {
    name: 'Croatia',
    iso: 'HR',
    isoAlt: 'HRV',
  },
  {
    name: 'Cuba',
    iso: 'CU',
    isoAlt: 'CUB',
  },
  {
    name: 'Curacao',
    iso: 'CW',
    isoAlt: 'CUW',
  },
  {
    name: 'Cyprus',
    iso: 'CY',
    isoAlt: 'CYP',
  },
  {
    name: 'Czech Republic',
    iso: 'CZ',
    isoAlt: 'CZE',
  },
  {
    name: "Cote d'Ivoire",
    iso: 'CI',
    isoAlt: 'CIV',
  },
  {
    name: 'Denmark',
    iso: 'DK',
    isoAlt: 'DNK',
  },
  {
    name: 'Djibouti',
    iso: 'DJ',
    isoAlt: 'DJI',
  },
  {
    name: 'Dominica',
    iso: 'DM',
    isoAlt: 'DMA',
  },
  {
    name: 'Dominican Republic',
    iso: 'DO',
    isoAlt: 'DOM',
  },
  {
    name: 'Ecuador',
    iso: 'EC',
    isoAlt: 'ECU',
  },
  {
    name: 'Egypt',
    iso: 'EG',
    isoAlt: 'EGY',
  },
  {
    name: 'El Salvador',
    iso: 'SV',
    isoAlt: 'SLV',
  },
  {
    name: 'Equatorial Guinea',
    iso: 'GQ',
    isoAlt: 'GNQ',
  },
  {
    name: 'Eritrea',
    iso: 'ER',
    isoAlt: 'ERI',
  },
  {
    name: 'Estonia',
    iso: 'EE',
    isoAlt: 'EST',
  },
  {
    name: 'Ethiopia',
    iso: 'ET',
    isoAlt: 'ETH',
  },
  {
    name: 'Falkland Islands (Malvinas)',
    iso: 'FK',
    isoAlt: 'FLK',
  },
  {
    name: 'Faroe Islands',
    iso: 'FO',
    isoAlt: 'FRO',
  },
  {
    name: 'Fiji',
    iso: 'FJ',
    isoAlt: 'FJI',
  },
  {
    name: 'Finland',
    iso: 'FI',
    isoAlt: 'FIN',
  },
  {
    name: 'France',
    iso: 'FR',
    isoAlt: 'FRA',
  },
  {
    name: 'French Guiana',
    iso: 'GF',
    isoAlt: 'GUF',
  },
  {
    name: 'French Polynesia',
    iso: 'PF',
    isoAlt: 'PYF',
  },
  {
    name: 'French Southern Territories',
    iso: 'TF',
    isoAlt: 'ATF',
  },
  {
    name: 'Gabon',
    iso: 'GA',
    isoAlt: 'GAB',
  },
  {
    name: 'Gambia',
    iso: 'GM',
    isoAlt: 'GMB',
  },
  {
    name: 'Georgia',
    iso: 'GE',
    isoAlt: 'GEO',
  },
  {
    name: 'Germany',
    iso: 'DE',
    isoAlt: 'DEU',
  },
  {
    name: 'Ghana',
    iso: 'GH',
    isoAlt: 'GHA',
  },
  {
    name: 'Gibraltar',
    iso: 'GI',
    isoAlt: 'GIB',
  },
  {
    name: 'Greece',
    iso: 'GR',
    isoAlt: 'GRC',
  },
  {
    name: 'Greenland',
    iso: 'GL',
    isoAlt: 'GRL',
  },
  {
    name: 'Grenada',
    iso: 'GD',
    isoAlt: 'GRD',
  },
  {
    name: 'Guadeloupe',
    iso: 'GP',
    isoAlt: 'GLP',
  },
  {
    name: 'Guam',
    iso: 'GU',
    isoAlt: 'GUM',
  },
  {
    name: 'Guatemala',
    iso: 'GT',
    isoAlt: 'GTM',
  },
  {
    name: 'Guernsey',
    iso: 'GG',
    isoAlt: 'GGY',
  },
  {
    name: 'Guinea',
    iso: 'GN',
    isoAlt: 'GIN',
  },
  {
    name: 'Guinea-Bissau',
    iso: 'GW',
    isoAlt: 'GNB',
  },
  {
    name: 'Guyana',
    iso: 'GY',
    isoAlt: 'GUY',
  },
  {
    name: 'Haiti',
    iso: 'HT',
    isoAlt: 'HTI',
  },
  {
    name: 'Heard Island and McDonald Islands',
    iso: 'HM',
    isoAlt: 'HMD',
  },
  {
    name: 'Holy See (Vatican City State)',
    iso: 'VA',
    isoAlt: 'VAT',
  },
  {
    name: 'Honduras',
    iso: 'HN',
    isoAlt: 'HND',
  },
  {
    name: 'Hong Kong',
    iso: 'HK',
    isoAlt: 'HKG',
  },
  {
    name: 'Hungary',
    iso: 'HU',
    isoAlt: 'HUN',
  },
  {
    name: 'Iceland',
    iso: 'IS',
    isoAlt: 'ISL',
  },
  {
    name: 'India',
    iso: 'IN',
    isoAlt: 'IND',
  },
  {
    name: 'Indonesia',
    iso: 'ID',
    isoAlt: 'IDN',
  },
  {
    name: 'Islamic Republic of Iran',
    iso: 'IR',
    isoAlt: 'IRN',
  },
  {
    name: 'Iraq',
    iso: 'IQ',
    isoAlt: 'IRQ',
  },
  {
    name: 'Ireland',
    iso: 'IE',
    isoAlt: 'IRL',
  },
  {
    name: 'Isle of Man',
    iso: 'IM',
    isoAlt: 'IMN',
  },
  {
    name: 'Israel',
    iso: 'IL',
    isoAlt: 'ISR',
  },
  {
    name: 'Italy',
    iso: 'IT',
    isoAlt: 'ITA',
  },
  {
    name: 'Jamaica',
    iso: 'JM',
    isoAlt: 'JAM',
  },
  {
    name: 'Japan',
    iso: 'JP',
    isoAlt: 'JPN',
  },
  {
    name: 'Jersey',
    iso: 'JE',
    isoAlt: 'JEY',
  },
  {
    name: 'Jordan',
    iso: 'JO',
    isoAlt: 'JOR',
  },
  {
    name: 'Kazakhstan',
    iso: 'KZ',
    isoAlt: 'KAZ',
  },
  {
    name: 'Kenya',
    iso: 'KE',
    isoAlt: 'KEN',
  },
  {
    name: 'Kiribati',
    iso: 'KI',
    isoAlt: 'KIR',
  },
  {
    name: "Democratic People's Republic of Korea",
    iso: 'KP',
    isoAlt: 'PRK',
  },
  {
    name: 'Republic of Korea',
    iso: 'KR',
    isoAlt: 'KOR',
  },
  {
    name: 'Kuwait',
    iso: 'KW',
    isoAlt: 'KWT',
  },
  {
    name: 'Kyrgyzstan',
    iso: 'KG',
    isoAlt: 'KGZ',
  },
  {
    name: "Lao People's Democratic Republic",
    iso: 'LA',
    isoAlt: 'LAO',
  },
  {
    name: 'Latvia',
    iso: 'LV',
    isoAlt: 'LVA',
  },
  {
    name: 'Lebanon',
    iso: 'LB',
    isoAlt: 'LBN',
  },
  {
    name: 'Lesotho',
    iso: 'LS',
    isoAlt: 'LSO',
  },
  {
    name: 'Liberia',
    iso: 'LR',
    isoAlt: 'LBR',
  },
  {
    name: 'Libya',
    iso: 'LY',
    isoAlt: 'LBY',
  },
  {
    name: 'Liechtenstein',
    iso: 'LI',
    isoAlt: 'LIE',
  },
  {
    name: 'Lithuania',
    iso: 'LT',
    isoAlt: 'LTU',
  },
  {
    name: 'Luxembourg',
    iso: 'LU',
    isoAlt: 'LUX',
  },
  {
    name: 'Macao',
    iso: 'MO',
    isoAlt: 'MAC',
  },
  {
    name: 'The Former Yugoslav Republic of Macedonia',
    iso: 'MK',
    isoAlt: 'MKD',
  },
  {
    name: 'Madagascar',
    iso: 'MG',
    isoAlt: 'MDG',
  },
  {
    name: 'Malawi',
    iso: 'MW',
    isoAlt: 'MWI',
  },
  {
    name: 'Malaysia',
    iso: 'MY',
    isoAlt: 'MYS',
  },
  {
    name: 'Maldives',
    iso: 'MV',
    isoAlt: 'MDV',
  },
  {
    name: 'Mali',
    iso: 'ML',
    isoAlt: 'MLI',
  },
  {
    name: 'Malta',
    iso: 'MT',
    isoAlt: 'MLT',
  },
  {
    name: 'Marshall Islands',
    iso: 'MH',
    isoAlt: 'MHL',
  },
  {
    name: 'Martinique',
    iso: 'MQ',
    isoAlt: 'MTQ',
  },
  {
    name: 'Mauritania',
    iso: 'MR',
    isoAlt: 'MRT',
  },
  {
    name: 'Mauritius',
    iso: 'MU',
    isoAlt: 'MUS',
  },
  {
    name: 'Mayotte',
    iso: 'YT',
    isoAlt: 'MYT',
  },
  {
    name: 'Mexico',
    iso: 'MX',
    isoAlt: 'MEX',
  },
  {
    name: 'Federated States of Micronesia',
    iso: 'FM',
    isoAlt: 'FSM',
  },
  {
    name: 'Republic of Moldova',
    iso: 'MD',
    isoAlt: 'MDA',
  },
  {
    name: 'Monaco',
    iso: 'MC',
    isoAlt: 'MCO',
  },
  {
    name: 'Mongolia',
    iso: 'MN',
    isoAlt: 'MNG',
  },
  {
    name: 'Montenegro',
    iso: 'ME',
    isoAlt: 'MNE',
  },
  {
    name: 'Montserrat',
    iso: 'MS',
    isoAlt: 'MSR',
  },
  {
    name: 'Morocco',
    iso: 'MA',
    isoAlt: 'MAR',
  },
  {
    name: 'Mozambique',
    iso: 'MZ',
    isoAlt: 'MOZ',
  },
  {
    name: 'Myanmar',
    iso: 'MM',
    isoAlt: 'MMR',
  },
  {
    name: 'Namibia',
    iso: 'NA',
    isoAlt: 'NAM',
  },
  {
    name: 'Nauru',
    iso: 'NR',
    isoAlt: 'NRU',
  },
  {
    name: 'Nepal',
    iso: 'NP',
    isoAlt: 'NPL',
  },
  {
    name: 'Netherlands',
    iso: 'NL',
    isoAlt: 'NLD',
  },
  {
    name: 'New Caledonia',
    iso: 'NC',
    isoAlt: 'NCL',
  },
  {
    name: 'New Zealand',
    iso: 'NZ',
    isoAlt: 'NZL',
  },
  {
    name: 'Nicaragua',
    iso: 'NI',
    isoAlt: 'NIC',
  },
  {
    name: 'Niger',
    iso: 'NE',
    isoAlt: 'NER',
  },
  {
    name: 'Nigeria',
    iso: 'NG',
    isoAlt: 'NGA',
  },
  {
    name: 'Niue',
    iso: 'NU',
    isoAlt: 'NIU',
  },
  {
    name: 'Norfolk Island',
    iso: 'NF',
    isoAlt: 'NFK',
  },
  {
    name: 'Northern Mariana Islands',
    iso: 'MP',
    isoAlt: 'MNP',
  },
  {
    name: 'Norway',
    iso: 'NO',
    isoAlt: 'NOR',
  },
  {
    name: 'Oman',
    iso: 'OM',
    isoAlt: 'OMN',
  },
  {
    name: 'Pakistan',
    iso: 'PK',
    isoAlt: 'PAK',
  },
  {
    name: 'Palau',
    iso: 'PW',
    isoAlt: 'PLW',
  },
  {
    name: 'State of Palestine',
    iso: 'PS',
    isoAlt: 'PSE',
  },
  {
    name: 'Panama',
    iso: 'PA',
    isoAlt: 'PAN',
  },
  {
    name: 'Papua New Guinea',
    iso: 'PG',
    isoAlt: 'PNG',
  },
  {
    name: 'Paraguay',
    iso: 'PY',
    isoAlt: 'PRY',
  },
  {
    name: 'Peru',
    iso: 'PE',
    isoAlt: 'PER',
  },
  {
    name: 'Philippines',
    iso: 'PH',
    isoAlt: 'PHL',
  },
  {
    name: 'Pitcairn',
    iso: 'PN',
    isoAlt: 'PCN',
  },
  {
    name: 'Poland',
    iso: 'PL',
    isoAlt: 'POL',
  },
  {
    name: 'Portugal',
    iso: 'PT',
    isoAlt: 'PRT',
  },
  {
    name: 'Puerto Rico',
    iso: 'PR',
    isoAlt: 'PRI',
  },
  {
    name: 'Qatar',
    iso: 'QA',
    isoAlt: 'QAT',
  },
  {
    name: 'Romania',
    iso: 'RO',
    isoAlt: 'ROU',
  },
  {
    name: 'Russian Federation',
    iso: 'RU',
    isoAlt: 'RUS',
  },
  {
    name: 'Rwanda',
    iso: 'RW',
    isoAlt: 'RWA',
  },
  {
    name: 'Reunion',
    iso: 'RE',
    isoAlt: 'REU',
  },
  {
    name: 'Saint Barthelemy',
    iso: 'BL',
    isoAlt: 'BLM',
  },
  {
    name: 'Saint Helena',
    iso: 'SH',
    isoAlt: 'SHN',
  },
  {
    name: 'Saint Kitts and Nevis',
    iso: 'KN',
    isoAlt: 'KNA',
  },
  {
    name: 'Saint Lucia',
    iso: 'LC',
    isoAlt: 'LCA',
  },
  {
    name: 'Saint Martin (French part)',
    iso: 'MF',
    isoAlt: 'MAF',
  },
  {
    name: 'Saint Pierre and Miquelon',
    iso: 'PM',
    isoAlt: 'SPM',
  },
  {
    name: 'Saint Vincent and the Grenadines',
    iso: 'VC',
    isoAlt: 'VCT',
  },
  {
    name: 'Samoa',
    iso: 'WS',
    isoAlt: 'WSM',
  },
  {
    name: 'San Marino',
    iso: 'SM',
    isoAlt: 'SMR',
  },
  {
    name: 'Sao Tome and Principe',
    iso: 'ST',
    isoAlt: 'STP',
  },
  {
    name: 'Saudi Arabia',
    iso: 'SA',
    isoAlt: 'SAU',
  },
  {
    name: 'Senegal',
    iso: 'SN',
    isoAlt: 'SEN',
  },
  {
    name: 'Serbia',
    iso: 'RS',
    isoAlt: 'SRB',
  },
  {
    name: 'Seychelles',
    iso: 'SC',
    isoAlt: 'SYC',
  },
  {
    name: 'Sierra Leone',
    iso: 'SL',
    isoAlt: 'SLE',
  },
  {
    name: 'Singapore',
    iso: 'SG',
    isoAlt: 'SGP',
  },
  {
    name: 'Sint Maarten (Dutch part)',
    iso: 'SX',
    isoAlt: 'SXM',
  },
  {
    name: 'Slovakia',
    iso: 'SK',
    isoAlt: 'SVK',
  },
  {
    name: 'Slovenia',
    iso: 'SI',
    isoAlt: 'SVN',
  },
  {
    name: 'Solomon Islands',
    iso: 'SB',
    isoAlt: 'SLB',
  },
  {
    name: 'Somalia',
    iso: 'SO',
    isoAlt: 'SOM',
  },
  {
    name: 'South Africa',
    iso: 'ZA',
    isoAlt: 'ZAF',
  },
  {
    name: 'South Georgia and the South Sandwich Islands',
    iso: 'GS',
    isoAlt: 'SGS',
  },
  {
    name: 'South Sudan',
    iso: 'SS',
    isoAlt: 'SSD',
  },
  {
    name: 'Spain',
    iso: 'ES',
    isoAlt: 'ESP',
  },
  {
    name: 'Sri Lanka',
    iso: 'LK',
    isoAlt: 'LKA',
  },
  {
    name: 'Sudan',
    iso: 'SD',
    isoAlt: 'SDN',
  },
  {
    name: 'Suriname',
    iso: 'SR',
    isoAlt: 'SUR',
  },
  {
    name: 'Svalbard and Jan Mayen',
    iso: 'SJ',
    isoAlt: 'SJM',
  },
  {
    name: 'Swaziland',
    iso: 'SZ',
    isoAlt: 'SWZ',
  },
  {
    name: 'Sweden',
    iso: 'SE',
    isoAlt: 'SWE',
  },
  {
    name: 'Switzerland',
    iso: 'CH',
    isoAlt: 'CHE',
  },
  {
    name: 'Syrian Arab Republic',
    iso: 'SY',
    isoAlt: 'SYR',
  },
  {
    name: 'Taiwan',
    iso: 'TW',
    isoAlt: 'TWN',
  },
  {
    name: 'Tajikistan',
    iso: 'TJ',
    isoAlt: 'TJK',
  },
  {
    name: 'United Republic of Tanzania',
    iso: 'TZ',
    isoAlt: 'TZA',
  },
  {
    name: 'Thailand',
    iso: 'TH',
    isoAlt: 'THA',
  },
  {
    name: 'Timor-Leste',
    iso: 'TL',
    isoAlt: 'TLS',
  },
  {
    name: 'Togo',
    iso: 'TG',
    isoAlt: 'TGO',
  },
  {
    name: 'Tokelau',
    iso: 'TK',
    isoAlt: 'TKL',
  },
  {
    name: 'Tonga',
    iso: 'TO',
    isoAlt: 'TON',
  },
  {
    name: 'Trinidad and Tobago',
    iso: 'TT',
    isoAlt: 'TTO',
  },
  {
    name: 'Tunisia',
    iso: 'TN',
    isoAlt: 'TUN',
  },
  {
    name: 'Turkey',
    iso: 'TR',
    isoAlt: 'TUR',
  },
  {
    name: 'Turkmenistan',
    iso: 'TM',
    isoAlt: 'TKM',
  },
  {
    name: 'Turks and Caicos Islands',
    iso: 'TC',
    isoAlt: 'TCA',
  },
  {
    name: 'Tuvalu',
    iso: 'TV',
    isoAlt: 'TUV',
  },
  {
    name: 'Uganda',
    iso: 'UG',
    isoAlt: 'UGA',
  },
  {
    name: 'Ukraine',
    iso: 'UA',
    isoAlt: 'UKR',
  },
  {
    name: 'United Arab Emirates',
    iso: 'AE',
    isoAlt: 'ARE',
  },
  {
    name: 'United Kingdom',
    iso: 'GB',
    isoAlt: 'GBR',
  },
  {
    name: 'United States',
    iso: 'US',
    isoAlt: 'USA',
  },
  {
    name: 'United States Minor Outlying Islands',
    iso: 'UM',
    isoAlt: 'UMI',
  },
  {
    name: 'Uruguay',
    iso: 'UY',
    isoAlt: 'URY',
  },
  {
    name: 'Uzbekistan',
    iso: 'UZ',
    isoAlt: 'UZB',
  },
  {
    name: 'Vanuatu',
    iso: 'VU',
    isoAlt: 'VUT',
  },
  {
    name: 'Venezuela',
    iso: 'VE',
    isoAlt: 'VEN',
  },
  {
    name: 'Viet Nam',
    iso: 'VN',
    isoAlt: 'VNM',
  },
  {
    name: 'British Virgin Islands',
    iso: 'VG',
    isoAlt: 'VGB',
  },
  {
    name: 'US Virgin Islands',
    iso: 'VI',
    isoAlt: 'VIR',
  },
  {
    name: 'Wallis and Futuna',
    iso: 'WF',
    isoAlt: 'WLF',
  },
  {
    name: 'Western Sahara',
    iso: 'EH',
    isoAlt: 'ESH',
  },
  {
    name: 'Yemen',
    iso: 'YE',
    isoAlt: 'YEM',
  },
  {
    name: 'Zambia',
    iso: 'ZM',
    isoAlt: 'ZMB',
  },
  {
    name: 'Zimbabwe',
    iso: 'ZW',
    isoAlt: 'ZWE',
  },
];
